<template>
  <component-wrapper class="price-list-fi">
    <grid-container-fi>
      <div class="fi-col-start-1 fi-col-end-13 lg:fi-col-start-2 lg:fi-col-end-12">
        <!-- eslint-disable vue/no-v-html -->
        <div
          v-if="isEditMode && fields.headline"
          class="price-list-fi__heading"
          v-html="fields.headline.editable"
        />
        <!-- eslint-enable vue/no-v-html -->
        <div
          v-if="!isEditMode && fields?.headline?.value"
          class="price-list-fi__heading"
        >
          {{ fields.headline.value }}
        </div>

        <div class="price-list-fi__items">
          <price-list-item-fi
            v-for="(priceListItem, index) in priceListItems"
            :key="`item${index}`"
            :fields="priceListItem.fields"
          />
        </div>
      </div>
    </grid-container-fi>
  </component-wrapper>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import ComponentWrapper from '@/components/component-wrapper/ComponentWrapper.vue';
import GridContainerFi from '@/components/grid-fi/GridContainerFi.vue';
import PriceListItemFi from '@/components/price-list-item-fi/PriceListItemFi.vue';
import type { PriceListFiFields } from '@/generated/fields';

defineOptions({ name: 'PriceListFi' });

const props = withDefaults(
  defineProps<{
    fields?: PriceListFiFields;
  }>(),
  {
    fields: () => ({}) as PriceListFiFields,
  },
);

const priceListItems = computed(() => props.fields?.priceListItems);
</script>

<style scoped src="./price-list-fi" />
